document.addEventListener("DOMContentLoaded", function () {

  const tabGroups = document.querySelectorAll(".pb-tabs");

  tabGroups.forEach(function (group) {

    const tabs = group.querySelectorAll(".pb-tab-btn");
    const contents = group.querySelectorAll(".pb-tab-content");

    tabs.forEach(function (tab) {

      tab.addEventListener("click", function () {

        tabs.forEach(function (btn) {
          btn.classList.remove("active");
        });

        contents.forEach(function (content) {
          content.classList.remove("active");
        });

        this.classList.add("active");

        const target = group.querySelector("#" + this.dataset.tab);

        if (target) {
          target.classList.add("active");
        }

      });

    });

  });

});